// extracted by mini-css-extract-plugin
export default {"fadeIn":"au_vNci8hVjoSH6470KE","onlineIconImgContainer":"YvBa_XoRancb1gmgcUkA","onlineIconImg":"mgK1y7giXWJ6TasTagtQ","summaryCard":"cs9hf4gD3Vptks4oNbWB"};